import { TablePagination } from "@mui/material";

function Pagination({
    data,
    setRowsPerPage,
    rowsPerPage,
    setCurrentPage,
    currentPage,
    lastPage
}) {
  if(typeof(rowsPerPage) !== 'number'){
    return (<></>);
  }
const handleChangePage = (event, newPage) => {
    if(newPage !== null){
        setCurrentPage(newPage + 1);
    }
    let currentCount = 0;
    data.map((ent) => {
        if (ent["page_no"] === currentPage) {
        currentCount = currentCount + 1;
        }
    });
    setRowsPerPage(currentCount);
    };
  return (
    <section className="reconcilation__verification__pagination">
          <h3 className="reconcilation__verification__text">
            Page {currentPage} of {lastPage}
          </h3>
        <TablePagination
        component="div"
        count={data.length - 1}
        rowsPerPage={parseInt(rowsPerPage)}
        page={currentPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangePage}
        nextIconButtonProps={{
            disabled: currentPage === lastPage ? true : false,
        }}
        // rowsPerPageOptions={[]}
        className={"reconcilation__verification__text reconcilation__verification__pagination"}
        />
    </section>
  )
}

export default Pagination